/** @jsx jsx */
import { Col, Row } from '@bottlebooks/gatsby-theme-base/src';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import useLink from '../../useLink';
import {
  ProductHeaderDetails,
  ProductName,
  ProductProducer,
} from '../Product/ProductHeader';
import ProductImageCol from './ProductImageCol';
import ProductNavigation from './ProductNavigation';

export default function ProductPageHeader({
  product,
  next,
  previous,
  overlapImage,
  className = '',
}) {
  const link = useLink();
  return (
    <ProductPageHeaderRow className={className}>
      <ProductImageCol product={product} overlap={overlapImage} />
      <ProductMainCol>
        <ProductProducer
          producer={product?.producer}
          to={link.producer(product?.producer)}
        />
        <ProductName as="h1" product={product} />
        <ProductHeaderDetails product={product} />
      </ProductMainCol>

      <ProductNavigation previous={previous} next={next} />
    </ProductPageHeaderRow>
  );
}

export function ProductPageHeaderRow({ children, ...rest }) {
  return (
    <Row sx={{ justifyContent: 'center' }} {...rest}>
      {children}
    </Row>
  );
}

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @returns
 */
export function ProductMainCol({ children }) {
  return (
    <Col
      sx={{
        paddingY: 4,
        flex: '1',
        minWidth: ['100%', 'unset'],
        order: [1, 'unset'],
      }}
    >
      {children}
    </Col>
  );
}

export const fragment = graphql`
  fragment ProductPageHeader_Navigation on Product {
    ...ChangeProductLink
    ...useLink_Product
  }
  fragment bb_ProductPageHeader on Bottlebooks_Product {
    ...bb_ProductHeaderDetails
    producer {
      ...useLink_bb_Producer
    }
  }
  fragment ProductPageHeader on Product {
    ...ProductImageLarge
    ...ProductProducerName
    ...ProductName
    ...ProductHeaderDetails
  }
`;
